module.exports = __webpack_public_path__ + "img/map_toilet_b1.05174e21.png";